module.exports = __webpack_public_path__ + "static/media/strata-logo-white-horiz.4711092f.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/strata-logo-white-horiz.png
// module id = 1492
// module chunks = 0